// extracted by mini-css-extract-plugin
export default {"outerFooter":"footer_outerFooter__IQ2IF","suport":"footer_suport__MTRyd","copyright":"footer_copyright__HzbVe","copyicon":"footer_copyicon__HT5hE"};